import { useQuery } from "@tanstack/react-query";

const useTodayTotalVolunteer = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: todayVolunteerInfo = [],
  } = useQuery({
    queryKey: ["todayVolunteerInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryListToday/${user_id}`
      );
      const data = await res.json();
      return data;
    },
  });
  return [todayVolunteerInfo, isLoading, isError, error, isSuccess, refetch];
};

export default useTodayTotalVolunteer;
